function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 1.7,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.122 15.74v7.706a2 2 0 002 2h14.293a2 2 0 002-2v-7.707h0M16.087 20.696V5M9.874 10.638L16.011 5l6.137 5.638"
}));

function SvgUiShare32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgUiShare32;